import React, {useContext, useEffect, useState, useCallback, useRef} from 'react';
import { debounce } from 'lodash';
import {IProps, IState} from './types';
import C from '@assets/themes/colors';
import * as S from './styles';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import EditBrandIcon from '@assets/icons/editBrandIcon';
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';
import Section from './Section';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import FilterCheck from '@components/Filter';
import ReplaceItem from './ReplaceItem';
import DeleteItem from './DeleteItem';
import AddElement from './AddElement';
import ViewAll from './ViewAll';
import { getLabelsFromSection } from '@utils/brand';
import { IUserType } from '@state/auth/types';
import ClickOutside from '@components/ClickOutside';
import ComboBox from '@components/ComboBox';
import { Industry } from '@state/industries/types';

const uuid = require('react-uuid');

const BrandDetail:React.FC<IProps> = (props) => {
  const [editName, setEditName] = useState<boolean>(false);
  const [industriesArray, setIndustriesArray] = useState<string[]>([]);
  const authContext = useContext(AuthContext);
  const{ brandDetail, setBrandDetail, addUpdateBrand, brandAction, viewAll} = useContext(BrandsContext);

  const brandNameResponse: any = useSelector(selectors.brands.getBrandName);
  const dispatch = useDispatch();

  const debounceFn = useCallback(debounce(addUpdateBrand, 1000), []);
  const industries =  useSelector(selectors.industries.getIndustries);

  const fetchBrandName = () => {
    const query = createQuery('names');
    return new Promise((resolve, reject) => {
      dispatch(actions.brands.fetchBrandName(query, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const createQuery=(option: string)=>{
    var finalQuery = "";
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    
    let status = `and c.status='ACTIVE'`;
    let orderBy = 'orderby=c.createdDate DESC';

    if (option === "names") {
      finalQuery = `?filter=c.formatName LIKE "%untitled%" ${status}&${orderBy}&start=0&pagelength=20`;
    }
    finalQuery = encodeURI(finalQuery);
    return finalQuery;
  }

  useEffect(() => {
    if (brandDetail.open && !brandDetail.brand ) {
      const run = async () => {     
        try {
          const infoName: any = await fetchBrandName();          
        } catch(error) {
          console.error(error);
        }
      }
      run();
    }
  }, [brandDetail])

  useEffect(() => {
    if (brandNameResponse) handleUpdateName(brandNameResponse.newName, true);
  }, [brandNameResponse])

  const handleUpdateName =  (newName: string, init?: boolean) => {
    let newBrand = (brandDetail?.brand!==null) ? {...brandDetail.brand, name: newName} : {id: null, name: newName }
    setBrandDetail({...brandDetail, brand: newBrand});

    if (Object.keys(newBrand).length>2) debounceFn(undefined,newName, undefined, undefined, newBrand);
  }

  const handleBrandOEM = (evt: any) => {    
    if (brandDetail?.brand?.id) addUpdateBrand(undefined, undefined, undefined, evt, undefined)
    //else {
      let newBrand =  {...brandDetail.brand, oem: evt, industry:undefined};
      setBrandDetail({...brandDetail, brand: newBrand});
    //}
  }

  const handleInputSave =  (event?: any, clickOutside?: boolean) => {
    if (brandDetail?.brand!==null && brandDetail?.brand.name!==brandNameResponse?.newName && (event?.charCode===13 || clickOutside)) {
      let newId = (brandDetail.brand.id===null || brandDetail.brand.id===undefined ) ? uuid() : undefined;
      setEditName(false);
      addUpdateBrand(undefined,undefined, newId, undefined, undefined, brandDetail.brand);
    }
  }

  const handleBrandIndustry = (industry: string) => {
    if (brandDetail?.brand?.id) addUpdateBrand(undefined, undefined, undefined, undefined, industry)
    //else {
      let newBrand =  {...brandDetail.brand, industry: industry};
      setBrandDetail({...brandDetail, brand: newBrand});
    //}
  }

  const elementName = getLabelsFromSection(brandAction?.section);


  const getIndustryName=(id:string)=>{    
    if (industries)
    {
       let ind = industries.find((f:Industry)=>f.id==id);
       if (ind)
        return ind.name
    }
    return '';
  }

  const getIndustryId=(name:string)=>{    
    if (industries)
    {
      let ind = industries.find((f:Industry)=>f.name==name);
      if (ind)
        return ind.id;
    }
    return ''
  }

  
useEffect(()=>{
  if (industries)
  {    
    let newIndustriesArray = industries.map((i:Industry)=>{
      return i.name;

    })
    setIndustriesArray(newIndustriesArray)
  }

},[industries])

  return (
    <>
    { viewAll?.open 
    ? <ViewAll handleWarningScreen={props.handleWarningScreen} />
    : <S.Root>
        
        {
          authContext.userData?.profile?.role === IUserType.ADMIN &&
          <S.OEMCheck>
            <FilterCheck checked={brandDetail?.brand?.oem} key={`setOem`} label={'Set as OEM'} type="" labelLeft={true} onChange={(label: string, type: string, evt:any)=> handleBrandOEM(evt)} labelStyle={{marginRight: "9px"}}/>
          </S.OEMCheck>
        }
        <S.Back onClick={()=>setBrandDetail(undefined)}>
          <S.Icon><ArrowLeftIcon fillColor={C.BLUE}/></S.Icon> BACK TO BRAND LIBRARY HOME
        </S.Back>
        {
          brandDetail.brand && brandDetail.brand.oem && !brandDetail.brand.useAsCommon &&
          <>
          <S.IndustryLabel>Industry:</S.IndustryLabel>
          <ComboBox
            id="industries"
            placeholder="Select Industry"
            options={industriesArray}
            required={false}
            disabled={false}
            position={"bottom"}
            chooseOption={(id:string, value:string) => handleBrandIndustry(getIndustryId(value))}
            //value={getIndustryName(brandDetail?.brand?.industry??'')}
            value={getIndustryName(brandDetail?.brand?.industry)}
            containerStyle={{
                padding: "0px",
                width: "256px",
                zIndex: "250",
                position: "absolute",
                right: '58px',
                top:'25px'
                
            }}
            optionContainerStyle={{top: '55px'}}>
            </ComboBox>
            </>
        }
        {!editName 
        ? <S.BrandNameLabel>{brandDetail?.brand?.name}<S.Edit onClick={()=> setEditName(true)}><EditBrandIcon style={{marginLeft: "12px"}}/></S.Edit></S.BrandNameLabel>
        : <S.BrandName autoFocus value={brandDetail?.brand?.name} onChange={(e: any) => handleUpdateName(e.target.value)} onKeyPress={(e: any) => handleInputSave(e)} onBlur={() => handleInputSave(undefined, true)}/>}
        
        
        <Section sectionName='Brand Logos' type="img" items={brandDetail?.brand?.logos} section={'logos'}/>
        <Section sectionName='Brand Color' type="color" items={brandDetail?.brand?.colors} section={'colors'}/>
        <Section sectionName='Brand Fonts' type="font" items={brandDetail?.brand?.fonts} section={'fonts'}/>
        <Section sectionName='Vehicle Images' type="img" items={brandDetail?.brand?.vehicles} section={'vehicles'}/>
        <Section sectionName='Stock Images' type="img" items={brandDetail?.brand?.stocks} section={'stocks'}/>
        <Section sectionName='Background Images' type="img" items={brandDetail?.brand?.backgrounds} section={'backgrounds'}/>
      </S.Root>}

    {((brandAction?.action === "add" || brandAction?.action === "metadata") && brandAction?.section !== "colors") &&
      <AddElement
        elementName={elementName}
        open={true}
        setOpen={()=>{}}
      />
    }

    { brandAction?.action === "replace" &&
      <ReplaceItem 
        elementName={elementName}
        open={true}
        setOpen={()=>{}}
        isSaving={false}
      />
    }

    { brandAction?.action === "delete" &&
      <DeleteItem 
        elementName={elementName}
        open={true}
        isSaving={false}
      />
    }
    </>
  );
}

export default BrandDetail;